var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1128_2176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9978 4.21777C4.9978 2.00864 6.78866 0.217773 8.9978 0.217773H40.9978C43.2069 0.217773 44.9978 2.00863 44.9978 4.21777V36.2178C44.9978 38.4269 43.2069 40.2178 40.9978 40.2178H8.9978C6.78866 40.2178 4.9978 38.4269 4.9978 36.2178V4.21777Z",
    fill: "#FDFEFF",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9992 20.5287C38.9992 19.3776 38.9039 18.5376 38.6976 17.6665H25.2849V22.862H33.1579C32.9992 24.1532 32.142 26.0976 30.2373 27.4042L30.2106 27.5781L34.4514 30.7978L34.7452 30.8265C37.4436 28.3842 38.9992 24.7909 38.9992 20.5287",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2841 34.2175C29.1412 34.2175 32.3792 32.973 34.7444 30.8264L30.2364 27.4041C29.0301 28.2285 27.411 28.8041 25.2841 28.8041C21.5064 28.8041 18.3001 26.3619 17.1571 22.9863L16.9896 23.0003L12.5799 26.3448L12.5222 26.5019C14.8714 31.0752 19.6968 34.2175 25.2841 34.2175Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1579 22.9867C16.8563 22.1156 16.6818 21.1822 16.6818 20.2178C16.6818 19.2533 16.8563 18.32 17.1421 17.4489L17.1341 17.2634L12.6691 13.8652L12.523 13.9333C11.5548 15.8311 10.9993 17.9623 10.9993 20.2178C10.9993 22.4734 11.5548 24.6044 12.523 26.5022L17.1579 22.9867",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2842 11.6311C27.9667 11.6311 29.7762 12.7666 30.808 13.7156L34.8397 9.85777C32.3636 7.60222 29.1413 6.21777 25.2842 6.21777C19.6968 6.21777 14.8714 9.35997 12.5222 13.9333L17.1413 17.4489C18.3001 14.0733 21.5064 11.6311 25.2842 11.6311",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1128_2176",
    x: 0.997803,
    y: 0.217773,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.298039 0 0 0 0 0.686275 0 0 0 0 0.890196 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1128_2176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1128_2176",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.ed6ec607984309e9e31e6222f5f9c1b1.svg";
export { ForwardRef as ReactComponent };